import React from 'react';
import { Typography } from '@mui/material';
import { BrokerGroupChip } from '../../shared/chips/BrokerGroupChip';
import { LedgerChip } from '../../shared/chips/LedgerChip';
import { SCOPES } from '@/features/config/scopes';

/** Where a config row comes from: a broker group, a ledger, or the default. */
export const FormFieldConfigSourceCell = ({ config }) => {
	if (config.scope === SCOPES.BROKER_GROUP) {
		return <BrokerGroupChip id={config.scopeId} />;
	}
	if (config.scope === SCOPES.LEDGER) {
		return <LedgerChip id={config.scopeId} />;
	}
	return (
		<Typography variant='body2' color='text.disabled'>
			Default
		</Typography>
	);
};

FormFieldConfigSourceCell.displayName = 'FormFieldConfigSourceCell';
